import Accordion from "@/components/Accordion";
import { LanguageConfigModel } from "@/pages/Messaging/types";
import React from "react";
import TextInput from "../../TextInput";
import { ChatWindow } from "../../types";

interface Props {
  onExpanded(): void;
  workingChatWindow: ChatWindow;
  setWorkingChatWindow: (chatWindow: ChatWindow) => void;
}

export function Sms(props: Props) {
  const workingLanguageConfig = props.workingChatWindow.languageConfig || {};

  const updateLanguageConfig = (updates: Partial<LanguageConfigModel>) => {
    props.setWorkingChatWindow({
      ...props.workingChatWindow,
      languageConfig: {
        ...workingLanguageConfig,
        ...updates
      }
    });
  };

  return (
    <Accordion.Item eventKey="sms" onExpanded={() => props.onExpanded()}>
      <Accordion.Header>
        <Accordion.Title>SMS</Accordion.Title>
      </Accordion.Header>
      <Accordion.Body>
        <div className="mb-2">
          <div className="text-sm font-medium mb-2">Header Title</div>
          <TextInput
            value={workingLanguageConfig.smsTitle}
            setValue={(value) => updateLanguageConfig({ smsTitle: value })}
            showEmojiButton={false}
            maxWordCount={undefined}
          />
          <div className="text-sm font-medium my-2">Header Sub Title</div>
          <TextInput
            value={workingLanguageConfig.smsSubTitle}
            setValue={(value) => updateLanguageConfig({ smsSubTitle: value })}
            showEmojiButton={false}
            maxWordCount={undefined}
          />
          <div className="text-sm font-medium my-2">Response Time Message</div>
          <TextInput
            value={workingLanguageConfig.smsResponseTime}
            setValue={(value) =>
              updateLanguageConfig({ smsResponseTime: value })
            }
            showEmojiButton={false}
            maxWordCount={undefined}
          />
          <div className="text-sm font-medium my-2">Form Header</div>
          <TextInput
            value={workingLanguageConfig.smsFormHeader}
            setValue={(value) => updateLanguageConfig({ smsFormHeader: value })}
            showEmojiButton={false}
            maxWordCount={undefined}
          />
          <div className="text-sm font-medium my-2">Form Footer</div>
          <TextInput
            value={workingLanguageConfig.smsFormFooter}
            setValue={(value) => updateLanguageConfig({ smsFormFooter: value })}
            showEmojiButton={false}
            maxWordCount={undefined}
          />
          <div className="text-sm font-medium my-2">Button Message</div>
          <TextInput
            value={workingLanguageConfig.smsButton}
            setValue={(value) => updateLanguageConfig({ smsButton: value })}
            showEmojiButton={false}
            maxWordCount={undefined}
          />
        </div>
      </Accordion.Body>
    </Accordion.Item>
  );
}
